import React from "react";
import "../Privacypolicy/Privacypolicy.css";
import { Helmet } from "react-helmet";

const Privacypolicy = () => {
  return (
    <>
      <Helmet>
        {/* ----------------------------------------------------
      BASIC SEO TAGS
  ---------------------------------------------------- */}
        <title>
          Privacy Policy & Disclaimer | ACE Hanei Sector 12 Noida Extension
        </title>
        <meta
          name="description"
          content="Privacy Policy and Disclaimer for ACE Hanei Sector 12 website. Learn about data protection, information usage, and legal disclaimers for ACE Group luxury apartments."
        />
        <meta
          name="keywords"
          content="ACE Hanei privacy policy, ACE Group disclaimer, data protection policy, website terms, ACE Hanei legal, RERA compliance, privacy terms, ACE Hanei terms of use, data security, information collection policy"
        />
        <link rel="canonical" href="https://acegroupsales.com/privacy" />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#ffffff" />

        {/* ----------------------------------------------------
      OPEN GRAPH TAGS
  ---------------------------------------------------- */}
        <meta
          property="og:title"
          content="Privacy Policy & Disclaimer - ACE Hanei Sector 12"
        />
        <meta
          property="og:description"
          content="Read the complete Privacy Policy and Disclaimer for ACE Hanei Sector 12 website. Information about data protection, legal terms, and RERA compliance."
        />
        <meta
          property="og:image"
          content="https://acegroupsales.com/poster.webp"
        />
        <meta property="og:url" content="https://acegroupsales.com/privacy" />
        <meta property="og:type" content="website" />

        {/* ----------------------------------------------------
      TWITTER META TAGS
  ---------------------------------------------------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Privacy Policy - ACE Hanei Luxury Apartments"
        />
        <meta
          name="twitter:description"
          content="Privacy Policy and Disclaimer for ACE Hanei Sector 12 website. Your data protection and legal information."
        />
        <meta
          name="twitter:image"
          content="https://acegroupsales.com/poster.webp"
        />

        {/* ----------------------------------------------------
      JSON-LD SCHEMA
  ---------------------------------------------------- */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "Privacy Policy & Disclaimer - ACE Hanei Sector 12",
              url: "https://acegroupsales.com/privacy",
              description:
                "Privacy Policy and Disclaimer for ACE Hanei Sector 12 website. Information about data protection, legal terms, RERA compliance, and user information policies.",
              primaryImageOfPage: {
                "@type": "ImageObject",
                url: "https://acegroupsales.com/poster.webp",
              },
              breadcrumb: {
                "@type": "BreadcrumbList",
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: "Home",
                    item: "https://acegroupsales.com/",
                  },
                  {
                    "@type": "ListItem",
                    position: 2,
                    name: "Privacy Policy",
                    item: "https://acegroupsales.com/privacy",
                  },
                ],
              },
              mainEntity: [
                {
                  "@type": "CreativeWork",
                  name: "Disclaimer - ACE Hanei Sector 12",
                  text: "This website is operated by an authorized channel partner of Ace Group - Shishir, UP RERA Registration No. UPRERAAGT24002. The content provided on this website is strictly for informational purposes. All images are for representational use only. Prices are subject to change without notice, and the availability of properties is not guaranteed. By accessing this website, users confirm that the information, including brochures and marketing materials, is solely for reference purposes, and no reliance should be placed on this information for making any booking or purchase of property in any project of the company. This website does not constitute advertising, marketing, booking, selling, or an offer to sell, nor does it represent an invitation to purchase any unit in any project of the company. The company assumes no liability for any actions taken by the user based on material or information from this website. The company has taken steps to verify the information and project compliances, including ensuring that the projects listed comply with the Real Estate Regulation Act (RERA) 2016. However, users should independently verify the RERA registration status of real estate projects before making any purchase decisions.",
                  keywords:
                    "disclaimer, legal notice, terms of use, RERA compliance, ACE Group",
                },
                {
                  "@type": "CreativeWork",
                  name: "Privacy Policy - ACE Hanei Sector 12",
                  text: "We are committed to protecting your personal information and have designed this privacy policy to safeguard your interests while using our website. This privacy policy is subject to periodic review and updates without prior notice. To stay informed of any changes, we encourage you to regularly review this policy. By using our website, you agree to abide by our terms and consent to the collection and use of any personal information you provide. While some sections of our website do not require personal information, certain features may require you to provide details such as your name, email address, or phone number. This information is used to deliver relevant services and to respond to communications or provide updates. You may opt out of our mailing list at any time. Rest assured, we do not share your personal information with any third party without your consent. To ensure the security of your sensitive information during transmission, we utilize advanced encryption protocols for all exchanges between your device and our servers. We also enforce restricted access and maintain high levels of confidentiality within our organization.",
                  keywords:
                    "privacy policy, data protection, personal information, data security, encryption",
                },
              ],
              about: {
                "@type": "Organization",
                name: "ACE Group",
                url: "https://acegroupsales.com/",
                logo: "https://acegroupsales.com/1.webp",
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "+917303734500",
                  contactType: "Privacy Inquiries",
                  availableLanguage: ["English", "Hindi"],
                },
                legalName: "ACE Group",
                foundingDate: "2000",
                address: {
                  "@type": "PostalAddress",
                  addressLocality: "Noida",
                  addressRegion: "Uttar Pradesh",
                  addressCountry: "IN",
                },
              },
              publisher: {
                "@type": "Organization",
                name: "ACE Group",
                url: "https://acegroupsales.com/",
                logo: "https://acegroupsales.com/1.webp",
              },
              provider: {
                "@type": "RealEstateAgent",
                name: "Authorized Channel Partner - Shishir",
                telephone: "+917303734500",
                identifier: "UP RERA Registration No. UPRERAAGT24002",
                address: {
                  "@type": "PostalAddress",
                  addressLocality: "Greater Noida West",
                  addressRegion: "Uttar Pradesh",
                  addressCountry: "IN",
                },
              },
              datePublished: "2024-01-01T00:00:00+05:30",
              dateModified: "2024-12-01T00:00:00+05:30",
              mainEntityOfPage: {
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "Who operates the ACE Hanei website?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "This website is operated by an authorized channel partner of Ace Group - Shishir, UP RERA Registration No. UPRERAAGT24002. The content is for informational purposes only.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Is the information on this website legally binding?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "No, all information including prices, images, and project details are for representational purposes only and subject to change without notice. This does not constitute an offer or invitation to purchase.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "What personal information do you collect?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "We may collect personal information such as name, email address, and phone number when you use certain features of our website. This information is used to provide services and respond to inquiries.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "How is my personal information protected?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "We use advanced encryption protocols for data transmission, enforce restricted access, and maintain high confidentiality standards to protect your sensitive information.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Can I opt out of communications?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "Yes, you may opt out of our mailing list at any time. We do not share your personal information with third parties without your consent.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "Is ACE Hanei RERA compliant?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "ACE Hanei Sector 12 has RERA registration number UPRERAPRJ677887. However, users are advised to independently verify RERA registration status before making any purchase decisions.",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "How often is the privacy policy updated?",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "This privacy policy is subject to periodic review and updates without prior notice. We encourage users to regularly review this policy for any changes.",
                    },
                  },
                ],
              },
              copyrightNotice:
                "© 2025 Ace Group. This website is operated by an authorized channel partner of Ace Group - Shishir, UP RERA Registration No. UPRERAAGT24002.",
              significantLink: [
                "https://acegroupsales.com/",
                "https://acegroupsales.com/about",
                "https://acegroupsales.com/contactus",
                "https://acegroupsales.com/pricelist",
              ],
              inLanguage: ["en-IN", "hi-IN"],
            }),
          }}
        />
      </Helmet>

      <section className="privacy-policy">
        <h4 className="hh">Disclaimer & Privacy Policy</h4>
        <div className="container">
          {/* Disclaimer Section */}
          <h2>Disclaimer</h2>
          <p>
            This website is operated by an authorized channel partner of Ace
            Group - Shishir , UP RERA Registration No. UPRERAAGT24002. The
            content provided on this website is strictly for informational
            purposes. All images are for representational use only. Prices are
            subject to change without notice, and the availability of properties
            is not guaranteed. By accessing this website, users confirm that the
            information, including brochures and marketing materials, is solely
            for reference purposes, and no reliance should be placed on this
            information for making any booking or purchase of property in any
            project of the company. This website does not constitute
            advertising, marketing, booking, selling, or an offer to sell, nor
            does it represent an invitation to purchase any unit in any project
            of the company. The company assumes no liability for any actions
            taken by the user based on material or information from this
            website. The company has taken steps to verify the information and
            project compliances, including ensuring that the projects listed
            comply with the Real Estate Regulation Act (RERA) 2016. However,
            users should independently verify the RERA registration status of
            real estate projects before making any purchase decisions.
          </p>

          {/* Privacy Policy Section */}
          <h2>Privacy Policy</h2>
          <p>
            We are committed to protecting your personal information and have
            designed this privacy policy to safeguard your interests while using
            our website.
          </p>

          <h3>Updating Our Privacy Policy</h3>
          <p>
            This privacy policy is subject to periodic review and updates
            without prior notice. To stay informed of any changes, we encourage
            you to regularly review this policy.
          </p>

          <h3>User Information</h3>
          <p>
            By using our website, you agree to abide by our terms and consent to
            the collection and use of any personal information you provide.
            While some sections of our website do not require personal
            information, certain features may require you to provide details
            such as your name, email address, or phone number. This information
            is used to deliver relevant services and to respond to
            communications or provide updates. You may opt out of our mailing
            list at any time. Rest assured, we do not share your personal
            information with any third party without your consent.
          </p>

          <h3>Security</h3>
          <p>
            To ensure the security of your sensitive information during
            transmission, we utilize advanced encryption protocols for all
            exchanges between your device and our servers. We also enforce
            restricted access and maintain high levels of confidentiality within
            our organization.
          </p>
        </div>
      </section>
    </>
  );
};

export default Privacypolicy;
